import { useEffect, useState } from 'react'

export const HERO_MESSAGES = [
  'This is our stage, this is our time',
  'Great run meetings are what leaders do. This is our stage.',
  "Let's push the world back, and let's have a great day connecting",
] as const

export const HERO_MESSAGE_INTERVAL_MS = 5500
export const HERO_MESSAGE_FADE_MS = 400

export function useRotatingHeroMessage(
  intervalMs: number = HERO_MESSAGE_INTERVAL_MS,
  fadeMs: number = HERO_MESSAGE_FADE_MS,
) {
  const [index, setIndex] = useState(0)
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (HERO_MESSAGES.length <= 1) return

    let fadeTimer: ReturnType<typeof setTimeout> | undefined

    const interval = setInterval(() => {
      setVisible(false)
      fadeTimer = setTimeout(() => {
        setIndex((i) => (i + 1) % HERO_MESSAGES.length)
        setVisible(true)
      }, fadeMs)
    }, intervalMs)

    return () => {
      clearInterval(interval)
      if (fadeTimer) clearTimeout(fadeTimer)
    }
  }, [intervalMs, fadeMs])

  return {
    message: HERO_MESSAGES[index],
    visible,
    fadeMs,
  }
}
